import { ConfigurationRoomsPage } from './../../../configuration/configuration-rooms/configuration-rooms';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { TPVServices } from "../../services";
import { TpvTicketPage } from "../../tpv-ticket/tpv-ticket";
import { Globals } from "../../../../globals";
import { ConfigurationRoomsCreateTablePage } from "../../../configuration/configuration-rooms/configuration-rooms-create/configuration-rooms-create-table/configuration-rooms-create-table";
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TpvTicketSelectedPayIndvPage } from '../../tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay-indv/tpv-ticket-selected-pay-indv';
import { TakeawayServices } from '../../../takeaway/services';
import { PopupTableWithTakeaway } from '../../../components/popups/popup-table-with-takeaway/popup-table-with-takeaway';

/**
 * Generated class for the TpvSelectRoomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-select-room',
  templateUrl: 'tpv-select-room.html',
})
export class TpvSelectRoomPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public takeawayServices: TakeawayServices,
    public modalCtrl: ModalController) {
  }

  disableTable(uid_room) {
    let styles;
    if (uid_room != this.tpvServices.room_selected_uid || !uid_room) {
      styles = {
        'display': 'none'
      };
    } else {
      styles = {
        'display': 'grid'
      };
    }
    return styles;
  }

  openTicket(index, type, value) {
    if (this.tpvServices.tables_array[index].state === 'takeaway') {
      let profileModal = this.modalCtrl.create(PopupTableWithTakeaway, {
        title: this.tpvServices.tables_array[index].name,
      });
      profileModal.onDidDismiss(data => {
        if (data) {
          if (data.option_selected === 'enter_state_open') {
            //
            this.tpvServices.afs.collection('tables').doc(this.tpvServices.tables_array[index].UID).update({
              'state': 'open',
            });
            //
            this.openTable(index, value);
          } else if (data.option_selected === 'enter') {
            this.openTable(index, value);
          } else if (data.option_selected === 'search_takeaway') {
            this.takeawayServices.table_takeaway_term = this.tpvServices.tables_array[index].uid_takeaway;
            this.tpvServices.menu_select_room = 'take_away';
          } else {//case raro/imposible
            this.openTable(index, value);
          }
        }

      });
      profileModal.present();
    } else {
      this.openTable(index, value);
    }
  }

  openTable(index, value) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //
    this.tpvServices.selected_table_tpv = value;
    this.tpvServices.selected_table_tpv_index = index;
    this.tpvServices.selected_type = 'table';
    //si tenemos un pago individual en curso enviamos a la pagina de pago para seguirlo
    if (this.tpvServices.tables_array[index].payment_individual) {
      this.navCtrl.push(TpvTicketSelectedPayIndvPage);
    }
    else {//si no tenemos pago individual en curso enviamos a la pagina de TpvTicketPage
      this.navCtrl.push(TpvTicketPage);
    }
    //
    if (this.globals.tour != '') {
      this.globals.tour_step_user = 3;
    }
    loadingPopup.dismiss();
  }

  openBarTicket() {
    this.tpvServices.selected_table_tpv_index = this.tpvServices.table_bar_index;
    this.tpvServices.selected_type = 'bar';
    this.navCtrl.push(TpvTicketPage);
  }

  createTable(room_uid, room_name) {
    this.globals.side_menu_config_active = 'rooms';
    this.navCtrl.push(ConfigurationRoomsCreateTablePage, {
      room_uid: room_uid,
      room_name: room_name,
      update: false,
    });
  }

  tableClass(table) {
    if (table.map_style) {
      let cssClasses = {
        'tpv-table-green': table.state === 'open',
        'tpv-table-yellow': table.state === 'ticket',
        'tpv-table-red': table.state === 'close',
        'tpv-table-blue': table.state === 'takeaway',
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'tpv-table-green': table.state === 'open',
        'tpv-table-yellow': table.state === 'ticket',
        'tpv-table-red': table.state === 'close',
        'tpv-table-blue': table.state === 'takeaway',
        'dnd-square': true,
      }
      return cssClasses;
    }
  }


  tableStyle(table) {

    if (!table.map_top) {
      table.map_top = 0;
    }
    if (!table.map_left) {
      table.map_left = 0;
    }
    let style = {
      'top': table.map_top + 'px',
      'left': table.map_left + 'px',
      'position': 'absolute',
    }

    if (table.uid_room != this.tpvServices.room_selected_uid || !table.uid_room) {
      style['display'] = 'none';
    }

    return style;
  }

  limitCharsClass(table) {
    let cssClasses = {};
    if (table.map_style) {
      cssClasses = {
        'limitCharsRooms-square': table.map_style === 'dnd-square',
        'limitCharsRooms-circle': table.map_style === 'dnd-circle',
        'limitCharsRooms-rectangle': table.map_style === 'dnd-rectangle',
        'limitCharsRooms-rectangle-vertical': table.map_style === 'dnd-rectangle-vertical',
        'limitCharsRooms-circle-big': table.map_style === 'dnd-circle-big',
        'limitCharsRooms-rectangle-big': table.map_style === 'dnd-rectangle-big',
        'limitCharsRooms-rectangle-big-vertical': table.map_style === 'dnd-rectangle-big-vertical',
      }
    } else {
      cssClasses = {
        'limitCharsRooms-square': 'dnd-square',
      }
    }
    return cssClasses;
  }

  openConfigRooms() {
    this.globals.side_menu_config_active = 'rooms';
    this.navCtrl.push(ConfigurationRoomsPage);
  }

  openVersionPro() {
    if (this.globals.checkLimitsByLicense('config', 'map')) {
      this.globals.side_menu_config_active = 'rooms';
      this.navCtrl.push(ConfigurationRoomsPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-select/tpv-select-room/tpv-select-room.ts